import store from '@/store'
import { ref } from '@vue/composition-api'

export const configTableComite = () => {
  const tableColumns = [
    { key: 'solicita', label: 'Solicita' },
    { key: 'curso', label: 'Datos' },
    { key: 'calif', label: 'Evualuacion' },
    { key: 'asignar', label: 'Asignar' },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    wsType: 'wscomitehonor', //* WebService name
    wsParams: { action: 3, token: store.state.cuenta.session.token }, //* Request params
    tiposolicitante: null, //* Filter
    filterGetter: 'comiteHonor/filterSalonesMoodle', //* Getter function to filter data
  })
  return {
    tableColumns,
    configRequest,
  }
}
//* Load filter options with promises
export const useComiteCatalogos = () => {
  const tipoSolicitante = [
    { label: 'Alumnos', value: 'ALU' },
    { label: 'Profesores', value: 'PROF' },
  ]
  return { tipoSolicitante }
}
